/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_ordered = /** @type {(inputs: {}) => string} */ () => {
	return `Objednáno`
};

const da_ordered = /** @type {(inputs: {}) => string} */ () => {
	return `Bestilt`
};

const de_ordered = /** @type {(inputs: {}) => string} */ () => {
	return `Bestellt`
};

const en_ordered = /** @type {(inputs: {}) => string} */ () => {
	return `Ordered`
};

const es_ordered = /** @type {(inputs: {}) => string} */ () => {
	return `Pedido`
};

const fr_ordered = /** @type {(inputs: {}) => string} */ () => {
	return `Commandé`
};

const hu_ordered = /** @type {(inputs: {}) => string} */ () => {
	return `Megrendelt`
};

const it_ordered = /** @type {(inputs: {}) => string} */ () => {
	return `Ordinato`
};

const nl_ordered = /** @type {(inputs: {}) => string} */ () => {
	return `Besteld`
};

const pl_ordered = /** @type {(inputs: {}) => string} */ () => {
	return `Zamówiono`
};

const pt_ordered = /** @type {(inputs: {}) => string} */ () => {
	return `Pedido realizado`
};

const sv_ordered = /** @type {(inputs: {}) => string} */ () => {
	return `Beställd`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ordered = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ordered(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("ordered", locale)
	if (locale === "cs") return cs_ordered(inputs)
	if (locale === "da") return da_ordered(inputs)
	if (locale === "de") return de_ordered(inputs)
	if (locale === "en") return en_ordered(inputs)
	if (locale === "es") return es_ordered(inputs)
	if (locale === "fr") return fr_ordered(inputs)
	if (locale === "hu") return hu_ordered(inputs)
	if (locale === "it") return it_ordered(inputs)
	if (locale === "nl") return nl_ordered(inputs)
	if (locale === "pl") return pl_ordered(inputs)
	if (locale === "pt") return pt_ordered(inputs)
	return sv_ordered(inputs)
};